import { OptimizelyFeatureFlags } from 'constants/featureFlags'
import { isAccommodationV2Booking } from 'lib/accommodation/isAccommodationV2Booking'
import { selectLoggedIn } from 'selectors/accountSelectors'
import { getSource } from 'selectors/offerSelectors'

function getAccommodationV2BookingContext(state: App.State) {
  return {
    isLoggedIn: selectLoggedIn(state),
    isAccommodationV2BookingsEnabled: !!state.optimizely.optimizelyFeatureFlags[OptimizelyFeatureFlags.sppAccommodationV2Bookings],
    source: getSource(state),
    utmContent: state.router.location.query.utm_content,
  }
}

/**
 * Whether any accommodationV2-bookable property would take that checkout path for this visitor.
 * Lets callers skip loading property content when the answer can't be yes.
 */
export function getCanBookAnyPropertyViaAccommodationV2(state: App.State): boolean {
  return isAccommodationV2Booking({ property: { accommV2Bookable: true }, ...getAccommodationV2BookingContext(state) })
}

/**
 * Whether booking this property now would take the accommodationV2 checkout path, using the same
 * gate as the SPP buy callbacks. Surfaces that path does not support yet (loyalty package upgrades)
 * hide themselves on this. Property content that hasn't loaded counts as not bookable, as in the gate.
 */
export function getIsAccommodationV2BookingForProperty(state: App.State, propertyId: string | undefined): boolean {
  const property = propertyId ? state.offer.properties[propertyId]?.property : undefined
  if (!property) return false
  return isAccommodationV2Booking({ property, ...getAccommodationV2BookingContext(state) })
}
